// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/checkbox/Uncontrolled.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Checkbox } from '@sail/ui';
export const Uncontrolled = () => {
  return <Checkbox onChange={e => {
    console.log(e.target.checked);
  }} defaultChecked label="This Checkbox is uncontrolled." />;
};